import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function AccountLinkIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props} viewBox="0 0 18 14">
      <g
        fill="#FFF"
        fillRule="evenodd"
        stroke="#2E3443"
        strokeLinejoin="round"
        transform="translate(1 1)"
      >
        <path d="M16.5.772v10.273l-12.196.927V1.676L16.5.772Z" />
        <path d="m-.5.445 5.576 1.298V12.06L-.5 10.784V.445Z" />
        <path d="m11.102-.504 8.35 1.831L4.769 2.416-3.399.606l14.501-1.11Z" />
        <ellipse cx="8.893" cy="6.192" rx="1.214" ry="1.282" />
        <ellipse cx="13.319" cy="5.975" rx="1.214" ry="1.282" />
        <ellipse cx="2.101" cy="6.305" rx="1" ry="1.464" />
      </g>
    </SvgIcon>
  );
}

export { AccountLinkIcon };
